(function () {
    'use strict';

    angular.module("imApp").factory("docPackTypeChaptersService", [function () {
        let service = {};

        return service;
    }]);
})();
